<template>
  <div class="spatial-filter-control" v-if="activeLayers.length > 0">
    <button class="spatial-trigger-btn" @click="toggleDropdown" title="Filtrar tabla por vista del mapa">
      <span class="fa-stack">
        <font-awesome-icon icon="map" class="fa-stack-1x" />
        <font-awesome-icon icon="filter" class="fa-stack-1x fa-inverse"
          style="font-size: 0.45em; margin-top: 5px; margin-left: 5px;" />
      </span>
    </button>

    <transition name="dropdown-fade">
      <div v-if="dropdownOpen" class="layer-dropdown">
        <div class="dropdown-header">Filtrar por vista actual</div>
        <ul class="layer-list">
          <li v-for="layer in activeLayers" :key="layer.id || layer.name"
              class="layer-item" @click="selectLayer(layer)">
            <font-awesome-icon icon="layer-group" class="layer-icon" />
            <span class="layer-name">{{ layer.name }}</span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapService } from "@/services/map/mapService";
import { attributesTableService } from "@/services/layers/attributesTable";

export default {
  name: "SpatialFilterControl",
  data() {
    return {
      dropdownOpen: false,
    };
  },
  computed: {
    activeLayers() {
      return this.$store.getters.getActiveLayers || [];
    },
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    async selectLayer(layer) {
      this.dropdownOpen = false;

      const extent = mapService.getExtent();
      if (!extent) return;

      const currentlyVisible = this.$store.getters["attributeTable/isVisible"];
      if (currentlyVisible) {
        this.$store.dispatch("attributeTable/closeTable");
      }

      await attributesTableService.openTable(layer, extent);
    },
  },
  created() {
    this.handleOutsideClick = (e) => {
      if (this.$el && !this.$el.contains(e.target)) {
        this.dropdownOpen = false;
      }
    };
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
};
</script>

<style scoped>
.spatial-filter-control {
  position: relative;
  z-index: 6000;
}

.spatial-trigger-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0f4c75;
  font-size: 1rem;
  transition: all 0.2s;
}

.spatial-trigger-btn:hover {
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transform: scale(1.05);
}

.spatial-trigger-btn .fa-stack {
  width: 1.2em;
  height: 1.2em;
  line-height: 1.2em;
}

.layer-dropdown {
  position: absolute;
  top: 42px;
  right: 0;
  left: auto;
  min-width: 220px;
  max-width: 300px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.dropdown-header {
  padding: 10px 14px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.layer-list {
  list-style: none;
  margin: 0;
  padding: 4px 0;
  max-height: 240px;
  overflow-y: auto;
}

.layer-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.15s;
  font-size: 0.85rem;
  color: #334155;
}

.layer-item:hover {
  background: #f1f7fc;
  color: #0f4c75;
}

.layer-icon {
  color: #3282b8;
  flex-shrink: 0;
}

.layer-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-fade-enter-active {
  transition: all 0.2s ease-out;
}
.dropdown-fade-leave-active {
  transition: all 0.15s ease-in;
}
.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
